<script lang="ts">
    import { Router, Route, links } from "svelte-routing"
    import { location } from "../store"
    import Header from "./Header.svelte"
    import Footer from "./Footer.svelte"
    import Mediathek from "./Mediathek.svelte"

    export let url = ""

    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            hash: "",
            push: false,
            pop: false,
        }
    }

    if (typeof window !== "undefined") {
        console.log("App initialized")
    }

    import Seite from "./Seite.svelte"
    import Fehler404 from "./Fehler404.svelte"
    import Favicon from "./Favicon.svelte"

    var utag_data = {
        sp_app_id: "vde8" /* BahnX Analytics app id */,
        sp_collector_url: "vde8.analytics.bahn-x.de" /* BahnX Analytics collector url */,
        cmp_legal_pages: ["/de/impressum", "/de/datenschutz"] /* Please update accordingly */,
        cmp_theme_name: "DB" /* Please remove if you do not wish to have DB Red buttons - check our documentation */,
    }
</script>

<svelte:head>
    <Favicon />
</svelte:head>

<div use:links>
    <Header />

    <div id="sitewrapper" data-url="{url}">
        <Router url="{url}">
            <Route path="/preview">
                <Seite pfad="" preview />
            </Route>

            <Route path="*pfad" let:params>
                <div class="container {params.pfad}">
                    <Seite pfad="{params.pfad}" />
                </div>
            </Route>

            <Route>
                <Fehler404 />
            </Route>
        </Router>
    </div>

    <Footer />
</div>

<style lang="less" global>
    @import "../css/style.less";
</style>
